import { Client } from '@models/clients';
import { Matter } from '@models/matter';
import { BusinessUser } from '@models/businesses';

export class SyncPortalEngineContextAndResponses {
	static readonly type = '[Portal Engine] Sync portal engine clients';
	constructor(
		public payload: {
			clients: Client[];
			matter: Matter;
			loggedInUser: BusinessUser;
		},
	) {}
}
